"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractRoutes = void 0;
var ContractRoutes;
(function (ContractRoutes) {
    ContractRoutes["BasePrefix"] = "contracts";
    ContractRoutes["ById"] = ":contractId";
    ContractRoutes["AllByClient"] = "all/:clientId";
    ContractRoutes["List"] = "list";
})(ContractRoutes = exports.ContractRoutes || (exports.ContractRoutes = {}));
